import React from 'react'
import Person from '../components/Person'

const content = [
  {
    type: 'text',
    text: 'Flo ist stark an Transportmitteln interessiert. So ist er zum Beispiel oft am Flughafen um Flugzeugen beim Start oder der Landung zuzusehen. Er hat auch großes Interesse in Autos und Zügen; er erwähnt häufig das neue Auto seines Vaters und trägt Freude an Zug- und Autofahrten.'
  },
  {
    type: 'img-full',
    position: 'left',
    imgId: 'das-project-foto-florim3_qqinir',
    alt: 'dasProject Foto Florim',
    aspectRatio: 1.5
  },
  {
    type: 'group',
    position: 'right',
    text: 'Montenegro Airlines ist seine Lieblingsfluglinie und der Favorit bei Autos ist Seat. Interesse ist aber immer da.',
    firstImg: {
      id: 'das-project-foto-florim5_ug7lhk',
      alt: 'dasProject Foto Florim',
      aspectRatio: 1.5
    },
    secondImg: {
      id: 'das-project-foto-florim2_ev2suv',
      alt: 'dasProject Foto Florim',
      aspectRatio: 1.5
    }
  },
  {
    type: 'text',
    text: 'Jeden Sommer ist Flo mit seiner Familie in Montenegro. Er freut sich sehr darauf und erzählt gerne davon. Flo ist übrigens der Spitzname für Florim. Flo vergibt auch gerne selbst Spitznamen, so wird aus Ben schnell mal Bem.'
  },
  {
    type: 'img-full',
    position: 'left',
    imgId: 'das-project-foto-florim4_qyiaus',
    alt: 'dasProject Foto Florim',
    aspectRatio: 1.5
  },
  {
    type: 'video',
    position: 'left',
    videoId: '219547219',
    alt: 'dasProject Video Florim'
  }
]

const color = 'orange'

export default class ReactComponent extends React.Component {
  render () {
    return (
      <div>
        <Person content={content} color={color} name='Flo' next={2} previous={0}/>
      </div>
    )
  }
}

exports.data = {
  color: 'orange',
  number: 2
}



// WEBPACK FOOTER //
// ./flo.js